<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
      <div :class="[ tab === 'svcs' ? 'active' : '' ]" @click="tab = 'svcs'">Services</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li @click="tab = 'svcs'">
          <a href="#">
            Services
            <i class="fa fa-check-square-o" v-if="tab === 'svcs'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="entity.id">
          <job-type-service v-show="entity.id && tab === 'svcs'" :job-type="entity.id"/>
        </div>
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="fjt-code" class="form-label">Code *</label>
              <input type="text" class="form-control" id="jt-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="fin-code-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="fin-code-name" v-model="entity.name"/>
            </div>
            <div class="form-group">
              <label for="jt-nat" class="form-label">Direction *</label>
              <select class="form-control" id="jt-nat" v-model="entity.nature">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('DIRECTION')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="jt-mode" class="form-label">Mode *</label>
              <select class="form-control" id="jt-mode" v-model="entity.mode">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('MODE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="jt-ser" class="form-label">Service provided *</label>
              <select class="form-control" id="jt-ser" v-model="entity.serviceProvided">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('SERVICE_PROVIDED')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="jt-tr" class="form-label">Transport type *</label>
              <select class="form-control" id="jt-tr" v-model="entity.transportType">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('TRANSPORT_TYPE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="jt-ship" class="form-label">Shipment type</label>
              <select class="form-control" id="jt-ship" v-model="entity.shipmentType">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('SHIPMENT_CATEGORY')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="jt-goods" class="form-label">Goods type *</label>
              <select class="form-control" id="jt-goods" v-model="entity.goodsType">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('GOODS_TYPE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="jt-goods" class="form-label">Wood/Loose</label>
              <select class="form-control" id="jt-goods" v-model="entity.woodLoose">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('WOOD_LOOSE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="jt-ng" class="form-label">Net-to-Gross *</label>
              <input type="number" step="0.01" class="form-control" id="jt-ng" v-model="entity.netToGross"/>
            </div>
            <div class="form-group">
              <label for="jt-den" class="form-label">Density *</label>
              <input type="number" step="0.01" class="form-control" id="jt-den" v-model="entity.density"/>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import API from '../../../../api/endpoints'
  import JobTypeService from './JobTypeService'
  export default {
    name: 'JobType',
    components: { JobTypeService },
    mixins: [AdminEntityMixin, HelperMixin],
    data () {
      return {
        validityCriteria: ['nature', 'mode', 'serviceProvided', 'transportType', 'goodsType', 'netToGross', 'density', 'name', 'code'],
        transformForUpdate: {
          nature: this.toMinus,
          mode: this.toMinus,
          serviceProvided: this.toMinus,
          transportType: this.toMinus,
          shipmentType: this.toMinus,
          goodsType: this.toMinus,
          woodLoose: this.toMinus,
          netToGross: this.toZero,
          density: this.toZero
        },
        newEntityScreen: 'Admin - Job Types',
        editEntityScreen: 'Admin - Edit/View Job Type',
        tab: 'main',
        boxes: [],
        entity: {
          id: null,
          code: null,
          name: null,
          nature: null,
          mode: null,
          serviceProvided: null,
          transportType: null,
          shipmentType: null,
          goodsType: null,
          woodLoose: null,
          netToGross: null,
          density: null
        },
        entityName: 'job-type'
      }
    },
    computed: {
      isValid () {
        let valid = true
        this.validityCriteria.forEach(prop => {
          valid = this.entity[prop] === '' || this.entity[prop] === null ? false : valid
        })
        return valid
      }
    },
    methods: {
      getBaseData () {
        return {
          id: null,
          code: null,
          name: null,
          nature: null,
          mode: null,
          serviceProvided: null,
          transportType: null,
          shipmentType: null,
          goodsType: null,
          woodLoose: null,
          netToGross: null,
          density: null
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// JobType.vue?447def81